import type { MapSearchInput } from '@/shared/utils/queryUtils'

export const creditsTableFields: MapSearchInput['path'] = {
    name: ['id', 'debtor.name', 'debtorIdentifier.value'],
    number: ['claimedAmount', 'amount']
}
